import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '../../../store/hooks/Redux'
import { selectUser } from '../../../store/reducers/AuthSlice'

/** GTM, Метрика и customer.io: к разметке лэйаута отношения не имеют */
export const useAnalytics = () => {
  const user = useAppSelector(selectUser)
  const location = useLocation()

  useEffect(() => {
    if (
      process.env.REACT_APP_PROJECT === 'bluepear' &&
      process.env.REACT_APP_BUILD_ENV === 'prod'
    ) {
      const gtagScript = document.createElement('script')
      gtagScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag("consent", "default", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied",
          functionality_storage: "denied",
          personalization_storage: "denied",
          security_storage: "granted",
          wait_for_update: 2000,
        });
        gtag("set", "ads_data_redaction", true);
        gtag("set", "url_passthrough", true);
      `
      document.head.appendChild(gtagScript)

      const gtmScript = document.createElement('script')
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-NKXFCZD');
      `
      document.head.appendChild(gtmScript)

      return () => {
        document.head.removeChild(gtagScript)
        document.head.removeChild(gtmScript)
      }
    }

    if (
      process.env.REACT_APP_PROJECT === 'robuscan' &&
      process.env.REACT_APP_BUILD_ENV === 'prod-robuscan-ru'
    ) {
      const gtmScript = document.createElement('script')
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PJ4D9G86');
      `
      document.head.appendChild(gtmScript)

      return () => {
        document.head.removeChild(gtmScript)
      }
    }
  }, [])

  useEffect(() => {
    if (process.env.REACT_APP_BUILD_ENV === 'prod' && !user.is_virtual_mode) {
      const metrikaScript = document.createElement('script')
      metrikaScript.innerHTML = `
      (function(m,e,t,r,i,k,a){
      m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) { if (document.scripts[j].src === r) { return; } }
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
      })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=104054433', 'ym');
      ym(104054433, 'init', { ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", accurateTrackBounce:true, trackLinks:true });`
      document.head.appendChild(metrikaScript)

      return () => {
        document.head.removeChild(metrikaScript)
      }
    }
  }, [])

  useEffect(() => {
    if (process.env.REACT_APP_PROJECT === 'bluepear' && !user.is_virtual_mode) {
      if (typeof ym === 'function') {
        ym(104054433, 'hit', location.pathname + location.search)
      }
    }
  }, [location])

  useEffect(() => {
    if (!localStorage.getItem('cio-identify') && user) {
      window.cioanalytics?.identify(String(user.id), {
        email: user.email,
        name: user.username,
      })

      localStorage.setItem('cio-identify', 'true')
    }
  }, [user])
}
